import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";

interface AuthErrorScreenProps {
	error: Error;
	onRetry: () => void;
}

/**
 * Error screen displayed when Auth0 authentication fails
 */
export const AuthErrorScreen: FC<AuthErrorScreenProps> = ({
	error,
	onRetry,
}) => {
	return (
		<Stack
			direction="column"
			justifyContent="center"
			alignItems="center"
			width={"100%"}
			height={"100vh"}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				spacing={2}
				maxWidth={500}
			>
				<img
					className="w-[269.1px] relative object-cover"
					alt="Authentication Error"
					src="/assets/error-icon.png"
					onError={(e) => {
						// Hide image if it doesn't exist
						e.currentTarget.style.display = "none";
					}}
				/>
				<Typography variant="h4" textAlign="center">
					Authentication Error
				</Typography>
				<Typography variant="body1" textAlign="center">
					{error.message || "An unexpected authentication error occurred"}
				</Typography>
				<Typography variant="body1" textAlign="center">
					Please try again. If the problem persists, contact your system
					administrator.
				</Typography>
				<Button variant="contained" color="primary" onClick={onRetry}>
					TRY AGAIN
				</Button>
			</Stack>
		</Stack>
	);
};
